<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  {{ message }}
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="onNoClick()">No</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</div>
